export const config = {
  apiURL: "https://api.example.com",
  appDisplayName: "Not configured",
  appName: "Not configured",
  includeCredentials: false,
};
